import React from "react";
import { IForm } from "../models/Form.model";
import { InputTextarea } from "primereact/inputtextarea";

interface SharedInputTextProps {
  item: IForm;
  handleFormData: any;
}

export default function SharedInputTextArea({
  item,
  handleFormData,
}: SharedInputTextProps) {
  return (
    <div className="form-group">
      <label>{item.label}</label>
      <InputTextarea
        value={item.value}
        placeholder={item.placeholder || ""}
        onChange={(e) => handleFormData(e.target.value)}
        rows={5}
        cols={30}
      />
    </div>
  );
}
